export default __webpack_public_path__ + "static/media/logo-dark.416d60ea.png";